import axios from "../../helpers/axios/axios";
import { BASE_URL } from "../../helpers/common/config";
import { errorHandler } from "../../helpers/common/utility";
import { setLoading } from "./";
import * as actionTypes from "../actions/types";

const setRencanaKontrol = (payload) => {
  return {
    type: actionTypes.SET_HISTORY_RENCANA_KONTROL,
    data: payload,
  };
};

const setHistoryFarmasi = (payload) => {
  return {
    type: actionTypes.SET_HISTORY_FARMASI,
    data: payload,
  };
};

const setHistoryLaboratorium = (payload) => {
  return {
    type: actionTypes.SET_HISTORY_LABORATORIUM,
    data: payload,
  };
};

const setHistoryRadiologi = (payload) => {
  return {
    type: actionTypes.SET_HISTORY_RADIOLOGI,
    data: payload,
  };
};

export const fetchRencanaKontrol = ({ rkun_id, onUnauth }) => {
  const url = BASE_URL + `/api/antrian/history/${rkun_id}/rencana-kontrol`;
  return (dispatch, state) => {
    dispatch(setLoading(true));
    axios
      .get(url, {
        headers: {
          "x-auth-token": state().auth.token,
        },
      })
      .then((payload) => {
        return dispatch(setRencanaKontrol(payload.data.data));
      })
      .catch((err) => {
        dispatch(setRencanaKontrol([]));
        if (err.response.status === 401) {
          return onUnauth();
        }
        return errorHandler(dispatch, err);
      })
      .finally(() => {
        return dispatch(setLoading(false));
      });
  };
};

export const openResumeMedis = ({ rkun_id }) => {
  const url = BASE_URL + `/api/antrian/history/${rkun_id}/resume`;
  return (dispatch, state) => {
    dispatch(setLoading(true));
    axios
      .get(url, {
        responseType: "blob",
        headers: {
          "x-auth-token": state().auth.token,
        },
      })
      .then((response) => {
        const file = new Blob([response.data], {
          type: "application/pdf",
        });

        const fileURL = URL.createObjectURL(file);

        // Buka di tab baru
        window.open(fileURL, "_blank");

        // Optional: cleanup memory
        setTimeout(() => URL.revokeObjectURL(fileURL), 1000);
      })
      .catch(async (err) => {
        if (err.response?.data instanceof Blob) {
          const text = await err.response.data.text();
          const json = JSON.parse(text);
          return errorHandler(dispatch, {
            response: {
              data: json,
            },
          });
        }

        return errorHandler(dispatch, err);
      })
      .finally(() => {
        return dispatch(setLoading(false));
      });
  };
};

export const fetchObatByRkun = ({ rkun_id }) => {
  const url = BASE_URL + `/api/antrian/history/${rkun_id}/farmasi`;
  return (dispatch, state) => {
    dispatch(setLoading(true));
    axios
      .get(url, {
        headers: {
          "x-auth-token": state().auth.token,
        },
      })
      .then((payload) => {
        return dispatch(setHistoryFarmasi(payload.data.data));
      })
      .catch((err) => {
        dispatch(setHistoryFarmasi([]));
        return errorHandler(dispatch, err);
      })
      .finally(() => {
        return dispatch(setLoading(false));
      });
  };
};

export const fetchLabByRkun = ({ rkun_id }) => {
  const url = BASE_URL + `/api/antrian/history/${rkun_id}/laboratorium`;
  return (dispatch, state) => {
    dispatch(setLoading(true));
    axios
      .get(url, {
        headers: {
          "x-auth-token": state().auth.token,
        },
      })
      .then((payload) => {
        return dispatch(setHistoryLaboratorium(payload.data.data));
      })
      .catch((err) => {
        dispatch(setHistoryLaboratorium([]));
        return errorHandler(dispatch, err);
      })
      .finally(() => {
        return dispatch(setLoading(false));
      });
  };
};

export const fetchRadByRkun = ({ rkun_id }) => {
  const url = BASE_URL + `/api/antrian/history/${rkun_id}/radiology`;
  return (dispatch, state) => {
    dispatch(setLoading(true));
    axios
      .get(url, {
        headers: {
          "x-auth-token": state().auth.token,
        },
      })
      .then((payload) => {
        return dispatch(setHistoryRadiologi(payload.data.data));
      })
      .catch((err) => {
        dispatch(setHistoryRadiologi([]));
        return errorHandler(dispatch, err);
      })
      .finally(() => {
        return dispatch(setLoading(false));
      });
  };
};

export const openHasilLab = (link) => {
  return (dispatch, state) => {
    dispatch(setLoading(true));
    axios
      .get(link, {
        responseType: "blob",
        headers: {
          "x-auth-token": state().auth.token,
        },
      })
      .then((response) => {
        const file = new Blob([response.data], {
          type: "application/pdf",
        });

        const fileURL = URL.createObjectURL(file);

        // Buka di tab baru
        window.open(fileURL, "_blank");

        // Optional: cleanup memory
        setTimeout(() => URL.revokeObjectURL(fileURL), 1000);
      })
      .catch(async (err) => {
        if (err.response?.data instanceof Blob) {
          const text = await err.response.data.text();
          const json = JSON.parse(text);
          return errorHandler(dispatch, {
            response: {
              data: json,
            },
          });
        }

        return errorHandler(dispatch, err);
      })
      .finally(() => {
        return dispatch(setLoading(false));
      });
  };
};
